import { useCallback, useMemo } from 'react';
import { UIReplacer, UIReplacerName } from 'src/components/TextWithUI/types';

export const useTextWithUIImagePreview = (): UIReplacer => {
  const onClick = useCallback((element: HTMLElement, event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    const src = element.closest('img')?.getAttribute('src')!;
    const href = element.closest('a')?.getAttribute('href')!;

    if (src && (!href || href !== src)) {
      window.open(src, '_blank');
    }
  }, []);

  return useMemo(
    () => ({
      name: UIReplacerName.ImagePreview,
      handlers: {
        onClick,
      },
    }),
    [onClick],
  );
};
